var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ivu-description-list",class:{ 'ivu-description-list-vertical': _vm.layout === 'vertical' }},[(_vm.title || _vm.$slots.title)?_c('div',{staticClass:"ivu-description-list-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_c('Row',{attrs:{"gutter":_vm.gutter}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/description-list/description-list.vue